import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button,
  CircularProgress,
  FormLabel,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material';
import { type Control, Controller } from 'react-hook-form';
import type { PasswordFormData } from './schema';
import { ContentBox } from '@/components/shared/content-box';
import { Api } from '@/constants';

const getAsset = (asset: string) => {
  return `${Api.EdupassApi}/contents/assets/${asset}`;
};

interface PasswordFormProps {
  control: Control<PasswordFormData>;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  submitting: boolean;
}

export const PasswordForm = ({
  control,
  onSubmit,
  submitting,
}: PasswordFormProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <Stack height="100vh" justifyContent="center" alignItems="center" p={2}>
      <ContentBox maxWidth="431px" width="100%" spacing={4} p={4}>
        <img
          src={getAsset('logo-galena-emails.png')}
          alt="Galena"
          width={141}
        />
        <form onSubmit={onSubmit}>
          <Stack spacing={3}>
            <Controller
              name="password"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Stack>
                  <FormLabel htmlFor="password">Nova senha</FormLabel>
                  <TextField
                    {...field}
                    id="password"
                    placeholder="Digite sua senha"
                    type={showPassword ? 'text' : 'password'}
                    error={!!error}
                    helperText={error?.message}
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={`${showPassword ? 'Ocultar' : 'Mostrar'} senha`}
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>
              )}
            />

            <Controller
              name="confirmPassword"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Stack>
                  <FormLabel htmlFor="confirmPassword">
                    Confirmar nova senha
                  </FormLabel>
                  <TextField
                    {...field}
                    id="confirmPassword"
                    placeholder="Digite novamente sua senha"
                    type={showConfirmPassword ? 'text' : 'password'}
                    error={!!error}
                    helperText={error?.message}
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={`${showConfirmPassword ? 'Ocultar' : 'Mostrar'} senha`}
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>
              )}
            />

            <Stack direction="row" justifyContent="flex-end">
              <Button type="submit" variant="contained" disabled={submitting}>
                {submitting ? <CircularProgress size={20} /> : 'Salvar'}
              </Button>
            </Stack>
          </Stack>
        </form>
      </ContentBox>
    </Stack>
  );
};
